import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ContentStackItem, ContentStackService } from '@app/core/_services/content-stack.service'
import { UserService } from '@app/core/_services/user.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faMessage, faVideo } from '@fortawesome/pro-regular-svg-icons'
import { faCalendar, faStar } from '@fortawesome/pro-solid-svg-icons'
import { RpScheduleComponent } from '../rp-schedule/rp-schedule.component'
import { FmAvatarComponent } from '@app/shared/components/fm-avatar/fm-avatar.component'
import { ButtonModule } from 'primeng/button'
import { FavoritesListComponent } from '@app/routes/availability/favorites/favorites-list.component'

@Component({
    selector: 'fm-rp-home',
    imports: [CommonModule, ButtonModule, FontAwesomeModule, RouterModule, FmAvatarComponent],
    templateUrl: './rp-home.component.html',
    styleUrl: './rp-home.component.scss',
})
export class RpHomeComponent {
    @Input() panelOpen: boolean = true
    constructor(
        private contentStackService: ContentStackService,
        public userService: UserService,
    ) {}
    faCalendar = faCalendar
    faStar = faStar
    faVideo = faVideo
    faMessage = faMessage

    ngOnInit() {}

    onClickYourSchedule(clearStack: boolean = false) {
        const stackItem: ContentStackItem = {
            component: RpScheduleComponent,
            popIfCovered: false,
            preserveStack: false,
            showRefreshButton: false,
        }
        if (clearStack) {
            this.contentStackService.clearContent()
        }

        this.contentStackService.pushContent(stackItem)
    }

    onClickFavoritesSchedule(): void {
        const stackItem: ContentStackItem = {
            component: FavoritesListComponent,
            context: { dynamicPanel: true },
            popIfCovered: true,
            preserveStack: false,
            showRefreshButton: true,
            sendToMainPanelUrl: '/availability/favorites',
        }
        this.contentStackService.pushContent(stackItem)
    }
}
